'use client';

import clsx from 'clsx';
import AppLink from '@/components/i18n/AppLink';
import { H2, P } from '@/components/ui';

export type HomeMidCtaSectionProps = {
  title: string;
  body: string;
  primaryHref: string;
  primaryLabel: string;
  secondaryHref: string;
  secondaryLabel: string;
  className?: string;
};

/** Mid-page conversion band — breaks scroll fatigue before social proof. */
const HomeMidCtaSection: React.FC<HomeMidCtaSectionProps> = ({
  title,
  body,
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
  className,
}) => (
  <section
    className={clsx('page-section-band page-section-band--accent', className)}
    aria-labelledby="home-mid-cta-heading"
  >
    <div className="container-section !min-h-0">
      <div className="page-cta-panel mx-auto max-w-4xl">
        <div className="page-cta-panel__inner text-center">
          <H2
            id="home-mid-cta-heading"
            className="m-0 text-xl font-semibold tracking-tight text-prose text-balance sm:text-2xl md:text-3xl"
          >
            {title}
          </H2>
          <P className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-prose-muted sm:text-base">{body}</P>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <AppLink href={primaryHref} btn="primary">
              {primaryLabel}
            </AppLink>
            <AppLink
              href={secondaryHref}
              className="text-sm font-medium text-prose-muted underline-offset-4 hover:text-prose hover:underline"
            >
              {secondaryLabel}
            </AppLink>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HomeMidCtaSection;